import { atom } from 'recoil';
import { DeliveryInfoResponse } from '@/types/api/mypage/deliveryInfo';

/**
 * 配送情報取得APIの結果を保持する state。
 * ONU や TA などの配送対象機器情報をまとめて保持し、配送確認画面の基礎データとして使う。
 */
export const deliveryState = atom<DeliveryInfoResponse>({
  key: 'DeliveryState',
  default: {
    onu: [
      {
        status: '',
        serial_no: '',
        model: '',
        link: '',
        optical_signal_status: '',
      },
    ],
    ta: [
      {
        status: '',
        serial_no: '',
        model: '',
        link: '',
      },
    ],
  },
});

export default deliveryState;
